module.exports = __webpack_public_path__ + "static/media/r4.49a9c4eb.png";